import { Styles } from 'react-jss'

export const sheet: Styles = {
  header: {
    justifyContent: 'space-between',
    padding: '16px 20px 8px 20px',
    borderBottom: '1px solid #E6E6E6'
  },
  btnWrapper: {
    padding: '12px 20px',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  btnRight: {
    display: 'flex',
    gap: '10px'
  },
  textWrapper: {
    padding: '16px 20px 16px 20px'
  }
}
